import React, { useEffect, useState, useRef } from 'react';
import NotificationAlert from 'react-notification-alert';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Modal,
  ModalBody,
  Table,
  Progress,
  Input,
} from 'reactstrap';
import { db } from '../../MY_LOGIN_AND_SIGNUP/db/config';
import { Edit, Delete } from '@mui/icons-material';
import DeleteBatch from './DeleteBatch';
import Add_Edit_Batch from './Add_Edit_Batch';
import format from 'date-fns/format';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';

import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import AddMaterial from './AddMaterial';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowLeftSharpIcon from '@mui/icons-material/KeyboardArrowLeftSharp';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import SelectedBatchDelete from './SelectedBatchDelete';
import { algoliaAppID, algoliaSearchID } from '../../Utilities/algoliaKeys';
import algoliasearch from 'algoliasearch/lite';
import SearchIcon from '@mui/icons-material/Search';
import firebase from 'firebase';
import { useNavigate } from 'react-router-dom';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

function BatchList() {
  const [limit, setLimit] = useState(10);
  const [teacherList, setTeacherList] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState({});
  const notification = useRef();
  const navigate = useNavigate()
  const [progressVisible, setProgressVisible] = useState(false);
  const [progressValue, setProgressValue] = useState(8);
  const [open, setOpen] = useState(false);
  const [batchData, setBatchData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentBatch, setcurrentBatch] = useState('');
  const [currentBatchId, setcurrentBatchId] = useState('');
  const [fullDialogOpen, setFullDialogOpen] = useState(false);
  const [allChecked, setAllChecked] = useState(false);
  const [isAllDeleteModalVisible, setIsAllDeleteModalVisible] = useState(false);
  const [selected, setSelected] = useState(false);
  const [selectedArr, setSelectedArr] = useState([]);
  const [batchSearchValue, setBatchSearchValue] = useState('');
  const searchClient = algoliasearch(algoliaAppID, algoliaSearchID);
  const batchSearchIndex = searchClient.initIndex('Batch_Search');
  const [search, setSearch] = useState(false);
  const [isTeacher, setIsTeacher] = useState(false);
const [currentUser, setCurrentUser] = useState();

  const getUsers = () => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        let uid = user.uid;
        console.log(uid);
        db.collection('zSystemUsers')
          .get()
          .then((querySnapshot) => {
            let data = querySnapshot.docs.map((doc) => doc.data());
            let currentUser = data.filter(
              (filterData) => filterData._uniqueID === uid
            );
            console.log('devIsChecking bool', currentUser);
            
            setCurrentUser(currentUser[0])
            if (currentUser[0]?.isTeacher) {
              setSelectedTeacher({
                batchIds: currentUser[0].isBatchManage,
                id: currentUser[0]._uniqueID,
                name: currentUser[0].firstname + " " + currentUser[0].lastname
              });
              // setSelectedTeacher(currentUser[0]);
              setIsTeacher(true);
              console.log('devIsChecking', currentUser);
            }
            console.log(currentUser, "currentUser");
          });
      } else {
        // User is signed out.
        // ...
      }
    });
  };

  const handlefullToggle = () => {
    setFullDialogOpen((prev) => !prev);
  };
  const [startIndex, setStartIndex] = useState(1);
  const [endIndex, setEndIndex] = useState(0);

  const notify = (msg, err) => {
    let color = err === true ? 'danger' : 'success';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err === true ? 'Error' : 'Success'}</b> -{msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notification.current) {
      notification.current.notificationAlert(options);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [batchStudents, setBatchStudents] = useState([]);

  const deleteBatch = (data) => {
    /*   console.log("deletebatch", data, "currentBranch", currentBatch); */
    const batchid = {
      batchID: currentBatch.itemID,
      batchName: currentBatch.batchName,
    };
    db.collection('MediaCenter')
      .where('batch', 'array-contains', batchid)
      .get()
      .then((query) => {
        console.log('query', query.docs);

        if (query.docs.length === 0) {
          if (!data.enrolledStudent || data.enrolledStudent == 0) {
            const afterDelete = batchData.filter(
              (item) => item.itemID !== data.itemID
            );
            setBatchData(afterDelete);

            db.collection('Batch')
              .doc(data.itemID)
              .delete()
              .then(() => {
                console.log('record deleted ');
                notify('Batch deleted successfully', false);
              })
              .catch((error) => {
                notify(error.toString(), true);
                console.log('this is error ', error);
              });
          } else {
            notify('This batch has students enrolled', true);
          }
        } else {
          notify('This batch has Active in Media Center', true);
        }

        query.docs.map((doc) => {
          console.log('batchdoc', doc.data().batch.length);
        });

        /*         setBatchStudents([...batchStudents, { id: "5B5zs5UnseiJH48ujsRp" }]);
        const batchfinal = [...batchStudents, { id: "5B5zs5UnseiJH48ujsRp" }];

        console.log("batchfinal", query.docs); */
      });
  };

  const nextSet = () => {
    document.querySelector('#loading-indicator').style.display = 'flex';

    db.collection('Batch')
      .orderBy('createdAt', 'desc')
      .startAfter(batchData[batchData.length - 1].createdAt)
      .limit(limit)
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => {
          return doc.data();
        });

        if (data.length !== 0) {
          document.querySelector('#loading-indicator').style.display = 'none';

          setBatchData(data);
          setStartIndex(endIndex + 1);
          setEndIndex((prev) => prev + data.length);
        } else {
          document.querySelector('#loading-indicator').style.display = 'none';

          notify('End Of the list', true);
        }
      })
      .catch((err) => {
        document.querySelector('#loading-indicator').style.display = 'none';
        notify(err.toString(), true);
        console.log(err.toString());
      });
  };

  const prevSet = () => {
    document.querySelector('#loading-indicator').style.display = 'flex';

    db.collection('Batch')
      .orderBy('createdAt')
      .startAfter(batchData[0].createdAt)
      .limit(limit)
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => {
          return doc.data();
        });

        if (data.length !== 0) {
          document.querySelector('#loading-indicator').style.display = 'none';

          data = data.reverse();

          setStartIndex((prev) => prev - data.length);
          setEndIndex((prev) => prev - batchData.length);
          setBatchData(data);
        } else {
          document.querySelector('#loading-indicator').style.display = 'none';
        }
      })
      .catch((err) => {
        document.querySelector('#loading-indicator').style.display = 'none';
        notify(err.toString(), true);
      });
  };

  const getStudentCountInBatch = async (batchId) => {
    try {
      const querySnapshot = await db
        .collection('zSystemStudents')
        .where('batch', 'array-contains', batchId)
        .get();

      console.log(`Total students in batch ${batchId}:`, querySnapshot.size);
      return querySnapshot.size; // Returns the count of students
    } catch (error) {
      console.error('Error fetching student count:', error);
      return 0;
    }
  };

  const getBatchData = async () => {
    console.log('isHave Runed', selectedTeacher?.batchIds?.length);
    document.querySelector('#loading-indicator').style.display = 'flex';

    if (!selectedTeacher?.batchIds?.length && !(selectedTeacher?.batchIds?.length == 0)) {
      // Case when batchIds is empty: Fetch all batches
      try {
        const querySnapshot = await db
          .collection('Batch')
          .orderBy('createdAt', 'desc')
          .limit(limit)
          .get();

        let data = querySnapshot.docs.map((doc) => ({
          ...doc.data(),
          select: false,
        }));

        console.log(data, isTeacher, 'ofBatchData');

        setBatchData(data);
        setEndIndex(data.length);
      } catch (error) {
        console.error('Error fetching all batches:', error);
      }
    } else {
      // Case when batchIds has more than 10 items: Fetch in chunks
      const batchIds = selectedTeacher.batchIds;
      const chunkSize = 10;
      const chunks = [];

      for (let i = 0; i < batchIds.length; i += chunkSize) {
        chunks.push(batchIds.slice(i, i + chunkSize));
      }

      try {
        let allData = [];

        await Promise.all(
          chunks.map(async (batchIdChunk) => {
            const querySnapshot = await db
              .collection('Batch')
              .where('itemID', 'in', batchIdChunk)
              .orderBy('createdAt', 'desc')
              .limit(limit)
              .get();

            const data = querySnapshot.docs.map((doc) => ({
              ...doc.data(),
              select: false,
            }));

            allData = [...allData, ...data];
          })
        );
        console.log(allData, 'ofBatchData');

        if (isTeacher) {
          const studentCountData = await Promise.all(
            allData.map(async (batch) => {
              const count = await getStudentCountInBatch(batch.itemID);
              return { ...batch, studentCount: count }; // Add count to batch
            })
          );
          allData = studentCountData
        }
        setBatchData(allData);
        setEndIndex(allData.length);
      } catch (error) {
        console.error('Error fetching batches by IDs:', error);
      }
    }

    setProgressVisible(false);
    document.querySelector('#loading-indicator').style.display = 'none';
  };


  useEffect(() => {
    getUsers()
    getTeacher();
  }, []);

  useEffect(() => {
    setProgressValue(99);
    console.log("selectedTeacherselectedTeacher",currentUser,selectedTeacher,limit);
    if (currentUser?._uniqueID) {
      getBatchData();
    }
  }, [limit, currentUser,selectedTeacher]);



  const batchSearch = () => {
    if (batchSearchValue == '') {
      notify('Search field can not be empty', true);
    } else {
      setSearch(true);
      document.querySelector('#loading-indicator').style.display = 'flex';

      batchSearchIndex
        .search(batchSearchValue, { typoTolerance: false })
        .then((result) => {
          if (result.hits.length === 0) {
            document.querySelector('#loading-indicator').style.display = 'none';

            notify('No results found', true);
          } else {
            document.querySelector('#loading-indicator').style.display = 'none';

            setBatchData(result.hits);
            // setReload(true);
          }
        })
        .catch((err) => {
          if (document.querySelector('#loading-indicator') !== null)
            document.querySelector('#loading-indicator').style.display = 'none';
          notify(err.toString(), true);
        });
    }
  };

  const deleteSelected = () => {
    let selectedId = [];
    batchData.map((item) => {
      if (item.select && item.itemID != undefined) {
        selectedId.push(item.itemID);
      }
    });

    let batch = db.batch();
    for (let i = 0; i < selectedId.length; i++) {
      batch.delete(db.collection('Batch').doc(selectedId[i]));
    }

    batch
      .commit()
      .then(() => {
        setBatchData((prev) =>
          prev.filter((item) => !selectedId.includes(item.itemID))
        );
        setIsAllDeleteModalVisible(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const emptyCall = () => {
    getBatchData();
    setSearch(false);
  };


  const getTeacher = async () => {
    try {
      const userSnapshot = await db.collection('zSystemUsers')
        .where('isTeacher', '==', true)
        .where('status', '==', 0)
        .get();

      let teacher = userSnapshot.docs.map(doc => ({ id: doc.id, batchIds: doc.data().isBatchManage, name: doc.data().firstname + " " + doc.data().lastname }));
      // setSelectedTeacher(teacher[0] || [])
      setTeacherList(teacher);
    } catch (error) {
      console.log(error);
    }
  }

  const studentCountRedirectHandler = (batch) => {
    try {
      // console.log(batch, { batchName: batch.batchName, batchId: batch.itemID });
      navigate('/admin/teacher-batch-student', { state: { batchName: batch.batchName, batchId: batch.itemID } })
    } catch (error) {
      console.log(error);
    }
  }


  return (
    <>
      {progressVisible ? (
        <>
          <Progress color='info' value={progressValue} style={{ height: 4 }} />
        </>
      ) : (
        <>
          <div className='content'>
            <div className='react-notification-alert-container'>
              <NotificationAlert ref={notification} />
            </div>
            <Modal
              isOpen={deleteModal}
              color='primary'
              style={{
                display: 'flex',
                flex: 1,
                top: -40,
                width: 250,
                backgroundColor: '#132639',
                objectFit: 'fill',
              }}
            >
              <ModalBody size='sm'>
                <DeleteBatch
                  deleteBatch={() => deleteBatch(currentBatch)}
                  setDeleteModal={setDeleteModal}
                ></DeleteBatch>
              </ModalBody>
            </Modal>
            <Modal
              isOpen={isAllDeleteModalVisible}
              color='primary'
              style={{
                display: 'flex',
                flex: 1,
                top: -40,
                width: 350,
                backgroundColor: '#132639',
                objectFit: 'fill',
              }}
            >
              <ModalBody size='sm' style={{ textAlign: 'center' }}>
                <SelectedBatchDelete
                  setIsAllDeleteModalVisible={setIsAllDeleteModalVisible}
                  deleteSelected={deleteSelected}
                />
              </ModalBody>
            </Modal>
            <Modal
              isOpen={open}
              style={{ display: 'flex', flex: 1, minWidth: '85%' }}
            >
              <ModalBody
                style={{
                  width: '100%',
                  display: 'inline-block',
                  padding: '0px !important',
                  position: 'absolute',
                  border: '1px solid white !important',
                }}
                size='sm'
              >
                <Add_Edit_Batch
                  currentBatch={currentBatch}
                  setBatchData={setBatchData}
                  notify={notify}
                  handleClose={handleClose}
                />
              </ModalBody>
            </Modal>

            <Dialog
              fullScreen
              open={fullDialogOpen}
              onClose={handlefullToggle}
              TransitionComponent={Transition}
            >
              <AddMaterial
              batchData={batchData}
              currentUser ={currentUser}
                notifi={notify}
                currentBatchId={currentBatchId}
                handleClose={handlefullToggle}
              />
            </Dialog>
            <Row>
              <Col md='12'>
                <Card>
                  <CardHeader>
                    <Row>
                      <Col sm={9} style={{ textAlign: 'center' }}>
                        <CardTitle
                          tag='h4'
                          style={{ fontWeight: 300, textAlign: 'left' }}
                        >
                          BATCH MANAGEMENT
                        </CardTitle>
                      </Col>
                      <Col sm={3}>
                        {!isTeacher &&
                          <Button
                            color='info'
                            style={{ float: 'right' }}
                            onClick={() => {
                              setcurrentBatch('');
                              handleClickOpen();
                            }}
                          >
                            Add Batch
                          </Button>}
                      </Col>
                    </Row>
                    <Row>
                      {
                        <Col sm={5}>
                          <div style={{ display: 'flex' }}>
                            {!isTeacher &&
                              <select
                                id="subject"
                                className="form-control"
                                value={selectedTeacher?.id || ""}
                                onChange={(e) => {
                                  if (e.target.value != "") {
                                    const currentTeacher = teacherList.find(teacher => teacher.id.toString() === e.target.value);
                                    setSelectedTeacher(currentTeacher);
                                    console.log(e.target.value, currentTeacher, 'isSelected');
                                  } else {
                                    console.log('isSetEmpty');
                                    setSelectedTeacher([])
                                  }
                                }}
                                style={{
                                  maxWidth: '200px',
                                  border: '1px solid rgb(42.67, 52.71, 82.83)',
                                  borderRadius: '4px',
                                  padding: '5px 10px',
                                }}
                              >
                                <option value=""> View All Teacher Batch</option>
                                {teacherList.map((teacher) => (
                                  <option key={teacher.id} value={teacher.id}>
                                    {teacher.name}
                                  </option>
                                ))}
                              </select>
                            }
                            <Input
                              type='text'
                              style={{ marginLeft: '4px' }}
                              name='searchInvoice'
                              placeholder='Search Batch'
                              onInput={(e) => {
                                setBatchSearchValue(e.target.value);
                                e.target.value.length === 0 && emptyCall();
                              }}
                            />
                          </div>
                        </Col>
                      }
                      <Col style={{ paddingLeft: '0px' }} sm={2}>
                        <Button
                          style={{ margin: '0px', padding: '6px 10px' }}
                          color='info'
                          onClick={batchSearch}
                        >
                          <SearchIcon />
                        </Button>
                      </Col>
                      {!search && !selectedTeacher?.batchIds?.length && (
                        <Col
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                          }}
                          sm={5}
                        >
                          {batchData.length > 9 ?
                            <div style={{ display: 'flex',justifyContent:'center' }}>

                              <p
                                style={{
                                  width:'35px',
                                  position: 'relative',
                                  top: '11px',
                                  marginRight: '5px',
                                }}
                              >
                                {startIndex <= 1 ? 1 : startIndex} - {endIndex}
                              </p>
                              <div
                                style={{
                                  position: 'relative',
                                  marginRight: '5px',
                                }}
                              >
                                {startIndex > 1 && (
                                  <IconButton
                                    style={{ outline: 'none' }}
                                    onClick={() => {
                                      prevSet();
                                    }}
                                  >
                                    <KeyboardArrowLeftSharpIcon
                                      style={{ color: 'white' }}
                                    />
                                  </IconButton>
                                )}

                                <IconButton
                                  style={{ outline: 'none' }}
                                  onClick={() => nextSet()}
                                >
                                  <KeyboardArrowRightSharpIcon
                                    style={{ color: 'white' }}
                                  />
                                </IconButton>

                              </div>
                              <select
                                className='form-control'
                                style={{
                                  maxWidth: 67,
                                  marginRight: 10,
                                  position: 'relative',
                                  top: 3,
                                }}
                                value={limit}
                                onChange={(e) => setLimit(parseInt(e.target.value))}
                              // required
                              >
                                <option value='10'>10</option>
                                <option value='50'>50</option>
                                <option value='100'>100</option>
                              </select>
                            </div> : ''}
                        </Col>
                      )}
                      {selected || selectedArr.length > 0 ? (
                        <Col
                          style={{ paddingRight: '0px', marginTop: 4 }}
                          sm={1}
                        >
                          <Button
                            style={{ margin: '0px', padding: '6px 10px' }}
                            color='danger'
                            onClick={() => setIsAllDeleteModalVisible(true)}
                          >
                            <Delete />
                          </Button>
                        </Col>
                      ) : null}
                    </Row>
                  </CardHeader>
                  <CardBody>
                    {batchData.length > 0 ?
                      <Table className='tablesorter'>
                        <thead className='text-primary'>
                          <tr>
                            {!isTeacher && <th>
                              <input
                                type='checkbox'
                                checked={allChecked}
                                onChange={(e) => {
                                  let checked = e.target.checked;
                                  if (checked == true) {
                                    setSelected(true);
                                  } else {
                                    setSelected(false);
                                    setSelectedArr([]);
                                  }
                                  let checkedData = batchData.map((data) => {
                                    data.select = checked;
                                    return data;
                                  });
                                  setAllChecked(checked);
                                  setBatchData(checkedData);
                                }}
                              />
                            </th>}

                            <th style={{ textAlign: 'center' }}>Batch Name</th>
                            {!isTeacher && <th style={{ textAlign: 'center' }}>Period</th>}
                            {/* {!isTeacher && <th style={{ textAlign: 'center' }}>Timings</th>} */}
                            {/* {!isTeacher && <th style={{ textAlign: 'center' }}>Week Days</th>} */}
                            {!isTeacher && <th style={{ textAlign: 'center' }}>Action</th>}
                            {isTeacher && <th style={{ textAlign: 'center' }}>Student Count</th>}
                            <th style={{ textAlign: 'center' }}>
                              Study Material
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {batchData &&
                            batchData.map((item) => {
                              return (
                                <tr key={item.itemID}>
                                  {!isTeacher && <td>
                                    <input
                                      type='checkbox'
                                      checked={item.select}
                                      onChange={(e) => {
                                        let checked = e.target.checked;
                                        setBatchData(
                                          batchData.map((data) => {
                                            if (item.itemID === data.itemID) {
                                              data.select = checked;
                                              if (checked) {
                                                setSelectedArr((prev) => [
                                                  { id: item.itemID },
                                                  ...prev,
                                                ]);
                                              } else {
                                                setSelectedArr((prev) =>
                                                  prev.filter(
                                                    (dataId) =>
                                                      dataId.id !== item.itemID
                                                  )
                                                );
                                              }
                                            }
                                            if (e.target.checked == false) {
                                              setAllChecked(false);
                                            }
                                            return data;
                                          })
                                        );
                                      }}
                                    />
                                  </td>}
                                  <td style={{ textAlign: 'center' }}>
                                    {item.batchName}
                                  </td>
                                  {!isTeacher && <td style={{ textAlign: 'center' }}>
                                    {item.startDate
                                      ? format(
                                        new Date(item.startDate),
                                        'dd/MM/yyyy'
                                      )
                                      : 'N/A'}
                                    {' to '}
                                    {item.endDate
                                      ? format(
                                        new Date(item.endDate),
                                        'dd/MM/yyyy'
                                      )
                                      : 'N/A'}
                                  </td>}
                                  {/* {!isTeacher && <td style={{ textAlign: 'center' }}>
                                    {item?.classesOn?.map((items, i) => {
                                      // console.log('items.startTime',items.startTime)
                                      return `${items.startTime &&
                                        items.startTime !== undefined
                                        ? format(
                                          new Date(
                                            `2021-06-26T${items.startTime}`
                                          ),
                                          'hh:mm a'
                                        )
                                        : '--:--'
                                        } to ${items.endTime &&
                                          items.endTime !== undefined
                                          ? format(
                                            new Date(
                                              `2021-06-26T${items.endTime}`
                                            ),
                                            'hh:mm a'
                                          )
                                          : '--:--'
                                        }${item?.classesOn?.length - 1 === i
                                          ? ''
                                          : ','
                                        } `;
                                    })}
                                  </td>} */}
                                  {/* {!isTeacher && <td
                                    style={{ textAlign: 'center', width: '20%' }}
                                  >
                                    {item?.classesOn?.map(
                                      (items, i) =>
                                        `${items?.weekName}${item?.classesOn?.length - 1 === i
                                          ? ''
                                          : ','
                                        } `
                                    )}
                                  </td>} */}

                                  {/* <td style={{textAlign: "center" }}>{item.professorName}</td> */}
                                  {!isTeacher &&
                                    <td
                                      style={{ textAlign: 'center', minWidth: 70 }}
                                    >
                                      <Edit
                                        style={{
                                          color: '#247cf7',
                                          cursor: 'pointer',
                                        }}
                                        onClick={() => {
                                          setcurrentBatch(item);
                                          handleClickOpen();
                                        }}
                                      />
                                      <Delete
                                        onClick={() => {
                                          setcurrentBatch(item);
                                          setDeleteModal(true);
                                        }}
                                        style={{ color: 'red', cursor: 'pointer' }}
                                      />
                                    </td>
                                  }
                                  {isTeacher && (
                                    item?.studentCount ?
                                      <td style={{ textAlign: 'center' }} onClick={() => { studentCountRedirectHandler(item) }}>
                                        <div
                                          style={{
                                            background: 'transparent',
                                            width: 'fit-content',
                                            border: '0',
                                            color: '#277CF7',
                                            // color: 'white',
                                            margin: '0 auto',
                                            display: 'block',
                                            cursor: 'pointer',
                                            outline: 'none',
                                            fontWeight: 'bold',
                                          }}>

                                          {item?.studentCount}
                                        </div>
                                      </td> : <td style={{ textAlign: 'center' }}>0</td>
                                  )}
                                  <td
                                    style={{ textAlign: 'center', minWidth: 70 }}
                                  >
                                    <Button
                                      color='info'
                                      style={{
                                        paddingLeft: 10,
                                        paddingRight: 10,
                                      }}
                                      onClick={() => {
                                        setcurrentBatchId(item.itemID);
                                        handlefullToggle();
                                      }}
                                    >
                                      <LibraryBooksIcon /> /{' '}
                                      <QuestionAnswerIcon />
                                    </Button>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </Table> : <>
                        <div
                          style={{
                            textAlign: 'center',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            padding: '20px',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            marginTop: '20px',
                          }}
                        >
                          {isTeacher ? 'No Batch Assigned To This Teacher' : 'No Batch Yet Created'}
                        </div>
                      </>
                    }
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </>
      )}
    </>
  );
}

export default BatchList;
